import { createApp, type App } from 'vue';
import AntDesignVue from 'ant-design-vue';
import ManagerResidents from './index.vue';

const MOUNT_ID = 'lkManagerResidentsApp';

let managerResidentsApp: App<Element> | null = null;
let currentMountEl: HTMLElement | null = null;

export function initManagerResidents(root?: ParentNode): void {
  const mountEl = root
    ? (root.querySelector<HTMLElement>(`#${MOUNT_ID}`) ?? document.getElementById(MOUNT_ID))
    : document.getElementById(MOUNT_ID);

  if (!mountEl) {
    return;
  }

  if (managerResidentsApp && currentMountEl) {
    managerResidentsApp.unmount();
    currentMountEl.innerHTML = '';
  }

  const app = createApp(ManagerResidents);
  app.use(AntDesignVue);
  app.mount(mountEl);

  managerResidentsApp = app;
  currentMountEl = mountEl;
}
